module.exports = __webpack_public_path__ + "static/fonts/poppins-v5-latin-800-6f22cd6faf712f6973ee0f38cd38c0e6.woff2";